import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import {
  ICON_BUTTON_COLOR,
  ICON_BUTTON_DEFAULTS,
  ICON_BUTTON_ORDER,
} from "./icon-buttons-renderer.constants";

@Component({
  selector: 'icon-buttons-renderer',
  templateUrl: './icon-buttons-renderer.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslateModule, NgbTooltipModule]
})

export class IconButtonsRendererComponent implements ICellRendererAngularComp {
  actionButtons: any[] = [];
  params: ICellRendererParams;


  onUserAction(action) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      const configured = params.colDef.headerComponentParams;
      // Array only: `headerComponentParams` is an object for most other renderers, and a
      // column that hands this one an object would otherwise reach the template's `@for`.
      this.actionButtons = Array.isArray(configured)
        ? JSON.parse(JSON.stringify(configured))
            .map(item => this.resolveButton(item))
            // Stable sort, so the LEADING group keeps the order the column declared and
            // only edit/delete are moved - to the right, delete last.
            .sort((a, b) => a.order - b.order)
        : [];
    }
    else {
      this.actionButtons = [];
    }
  }

  /**
   * Fill an entry in from the renderer's icon set and resolve its row flags.
   *
   * A column names the `userAction` and gets icon, colour and position from
   * `ICON_BUTTON_DEFAULTS`. An explicit `buttonIcon` / `buttonClass` still wins so a
   * genuine one-off stays possible, but the default is what every grid should be using.
   */
  private resolveButton(item: any) {
    // A label-only entry belongs to `buttonsRenderer` (`buttonText`) or to
    // `clickToSetupRenderer` (`text`) - see the template's note. Give it no icon, or it
    // would start drawing here as a button this column never asked for, which the
    // `userAction`-keyed defaults below would otherwise hand it for free.
    const labelOnly = item.buttonText || item.text;
    const defaults = labelOnly ? null : ICON_BUTTON_DEFAULTS[item.userAction];
    return {
      ...item,
      buttonIcon: item.buttonIcon || defaults?.buttonIcon || '',
      buttonClass: item.buttonClass || defaults?.buttonClass || ICON_BUTTON_COLOR.NEUTRAL,
      order: item.order ?? defaults?.order ?? ICON_BUTTON_ORDER.LEADING,
      // Both arrive as row-flag NAMES and leave as the resolved boolean.
      disableProperty: item.disableProperty && this.params.data[item.disableProperty],
      hideProperty: item.hideProperty && this.params.data[item.hideProperty],
    };
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
